<script>
    import Layout from "../../layouts/main";
    import appConfig from "@/app.config";
    import SocialCard from "../../../components/socialCard";
    import OverviewConnectCard from "../../../components/overviewConnectCard";
    import NegotiationsItem from "../../../components/clientNegotiations/NegotiationsItem";
    import {mapGetters, mapState} from "vuex";
    import axios from "axios";
    import AgreementContent from '../../../components/clientNegotiations/AgreementContent.vue';
    import Swal from "sweetalert2";

    /**
     * Dashboard Component
     */
    export default {
        page: {
            title: "Home",
            meta: [{name: "description", content: appConfig.description}],
        },
        components: {
            Layout,
            SocialCard,
            OverviewConnectCard,
            NegotiationsItem,
            AgreementContent
        },
        data() {
            return {
                title: "Home",
                items: [
                    {
                        text: "Dashboard",
                        href: "/",
                    },
                    {
                        text: "Home",
                        active: true,
                    },
                ],
                balance: {},
                scheduledPosts: [],
                recentPosts: [],
                showModal: false,
                modalAgreement: {},
                socialNetworkData: [],
                chartOptions: {
                    chart: {
                        type: 'area',
                        height: 80,
                        sparkline: {
                            enabled: true
                        }
                    },
                    stroke: {
                        curve: 'smooth',
                        width: 2,
                    },
                    colors: ['#f1b44c'],
                    xaxis: {
                        type: "datetime",
                        labels: {
                            show: false,
                        }
                    },
                    yaxis: {
                        labels: {
                            show: false,
                            formatter: function (val) {
                                return val.toFixed(0)
                            }
                        }
                    },
                    fill: {
                        type: 'gradient',
                        gradient: {
                            shadeIntensity: 1,
                            inverseColors: false,
                            opacityFrom: 0.45,
                            opacityTo: 0.05,
                            stops: [25, 100, 100, 100]
                        },
                    },
                    tooltip: {
                        fixed: {
                            enabled: false
                        },
                        x: {
                            show: true
                        },
                        marker: {
                            show: false
                        }
                    }
                },
                chartData: [
                    {
                        label: 'Total Audience',
                        name: 'audience',
                        value: '3,249',
                        positive: false,
                        badgeValue: '5%',
                        series: [{
                            name: 'New fans',
                            data: [12, 14, 2, 47, 42, 15, 47, 75, 65, 19, 14]
                        }]
                    },
                    {
                        label: 'Total Impressions',
                        name: 'impressions',
                        value: '6,546',
                        positive: false,
                        badgeValue: '5%',
                        series: [{
                            name: 'New impressions',
                            data: [15, 23, 24, 47, 42, 15, 3, 13, 65, 19, 14]
                        }]
                    },
                    {
                        label: 'Total Engagement',
                        name: 'engagement',
                        value: '2,249',
                        positive: true,
                        badgeValue: '2%',
                        series: [{
                            name: 'New Engagement',
                            data: [12, 14, 2, 47, 42, 15, 47, 75, 65, 19, 14]
                        }]
                    }
                ]
            };
        },
        async created() {
            // populate posts
            this.recentPosts = this.overview.recent_posts.map(this.mapRecentPosts);
            this.scheduledPosts = this.overview.scheduled_posts.map(this.mapScheduledPosts);

            this.chartData.forEach((chart) => {
                chart.value = this.overview.total.sums[chart.name].value;
                const newData = Object.entries(this.overview.total.daily).map(([key, value]) => {
                    return {
                        x: key,
                        y: value[chart.name]
                    }
                });
                chart.series = [{
                    name: chart.series[0].name,
                    data: newData
                }];
            });

            //check for awailable networks
            Object.keys(this.user.social_network_accounts).forEach((key) => {
                if (['facebook', 'instagram', 'youtube'].includes(key) && this.user.social_network_accounts[key]) {
                    this.socialNetworkData.push({
                        name: key,
                        accountName: this.user.social_network_accounts[key].name
                    });
                }
            });
            // fill available networks with data
            if (this.socialNetworkData.length > 0) {
                this.socialNetworkData = this.socialNetworkData.map((socialNetwork) => {
                    return {
                        ...socialNetwork,
                        engagement: this.overview.social_accounts_overview[socialNetwork.name].engagement,
                        engagement_rate: this.overview.social_accounts_overview[socialNetwork.name].engagement_rate,
                        followers: this.overview.social_accounts_overview[socialNetwork.name].followers,
                        impressions: this.overview.social_accounts_overview[socialNetwork.name].impressions
                    }
                });
            }

            // update offers
            const { data } = await axios.get('/influencer/home');
            this.$store.commit('overview/SET_OVERVIEW', data);

            // Get balance
            this.loadBalance()
        },
        computed: {
            ...mapState('user', {
                user: (state) => state.user,
            }),
            ...mapState('overview', {
                overview: (state) => state.overview,
            }),
            noConnectedAccounts() {
                return !(this.user.social_network_accounts.instagram || this.user.social_network_accounts.facebook || this.user.social_network_accounts.youtube || this.user.social_network_accounts.blog);
            },
            blog() {
                if (this.user.social_network_accounts.blog && this.overview.social_accounts_overview.blog) {
                    return {
                        name: 'blog',
                        website: this.user.social_network_accounts.blog.website_url,
                        ...this.overview.social_accounts_overview.blog
                    }
                }

                return null;
            },
            offersToShow () {
                return [...this.overview.offers].splice(0, 3);
            },
            hasOffers () {
                return this.overview.offers.length !== 0;
            },
            restOffers () {
                return this.overview.offers.length > 3 && this.overview.offers.length - 3;
            },
            loadedBalance() {
                return this.balance && this.balance.hasOwnProperty('available_balance')
            },
            canRequestPayout() {
               return this.balance.available_balance && (this.balance.available_balance - (this.payoutFeeEur * 1.2)) > 0
            },
            payoutFeeEur() {
              return this.user.influencer.payout_fee_eur;
            }
        },
        methods: {
            async openOffer (agreementId) {
                this.$store.commit('loader/START_LOADING');
                try {
                    const { data } = await axios.get(`/campaign-agreement/${agreementId}`);
                    this.modalAgreement = data;
                    this.showModal = true;
                } catch (e) {
                    // TODO
                } finally {
                    this.$store.commit('loader/END_LOADING');
                }
            },
            async refreshPage () {
                try {
                    await this.$store.dispatch('overview/getOverviewData');
                } catch (e) {
                    // TODO:
                }
            },
            mapRecentPosts (post) {
                let metrics = {};
                if ((post.info.social_network === 'instagram' && post.info.post_type === 'FEED') || post.info.social_network === 'facebook') {
                    metrics = {
                        impressions: post.insights.impressions,
                        engagement: post.insights.engagement,
                        reach: post.insights.reach
                    };
                } else if (post.info.social_network === 'instagram' && post.info.post_type === 'STORY') {
                    metrics = {
                        impressions: post.insights.impressions,
                        replies: post.insights.replies,
                        reach: post.insights.reach
                    };
                } else if (post.info.social_network === 'youtube') {
                    metrics = {
                        views: post.insights.views,
                        engagement: post.insights.engagement,
                        likes: post.insights.likes
                    };
                }
                return {
                    social_network: post.info.social_network,
                    media_url: post.info.media_url,
                    username: post.info.username,
                    metrics
                }
            },
            mapScheduledPosts (post) {
                return {
                    social_network: post.social_network,
                    media_url: post.cover_image_url,
                    external_post_id: post.external_post_id,
                    username: post.username,
                    publish_date: post.publish_date,
                    campaign_name: post.campaign_name
                }
            },
            async loadBalance() {
                const response = await axios.get('/profile/balance');
                this.balance = response.data
            },
            async requestPayout() {
                try {
                    const result = await Swal.fire({
                      title: "Payment request",
                      text: `Platform fee is ${this.payoutFeeEur * 1.2} EUR (VAT included). Your payment request will be paid ${this.balance.available_balance - (this.payoutFeeEur * 1.2)} EUR.`,
                      // icon: "info",
                      reverseButtons: true,
                      showCancelButton: true,
                      confirmButtonColor: "#2ca579",
                      cancelButtonColor: "#868585",
                      confirmButtonText: "Send request",
                      cancelButtonText: "Cancel"
                    })

                    if (!result.value) {
                      return;
                    }

                    this.$store.commit('loader/START_LOADING');

                    const response = await axios.post('/profile/balance/request-payout');
                    if (response.status === 201) {
                        this.$store.commit('loader/END_LOADING');

                        await Swal.fire({
                            title: "Nice!",
                            text: "We hereby confirm that we have received your payment request. When the bookkeeping team approves, the money will be paid out to the your account.",
                            icon: "success",
                            confirmButtonColor: "#01baf1",
                            confirmButtonText: "OK"
                        });
                        this.balance = {};
                        this.loadBalance();
                    }
                } catch (e) {
                    // eslint-disable-next-line no-console
                    console.error(e)
                }

            }
        }
    };
</script>

<template>
<!--    TODO: make offer column on top-->
<!--    TODO: open modal for offer card-->
    <Layout>
        <div v-if="noConnectedAccounts" class="row">
            <div class="col">
                <OverviewConnectCard/>
            </div>
        </div>
        <div v-else class="row">
            <div v-if="hasOffers" class="col-12">
                <div class="card">
                    <div class="card-body">
                        <h4 class="card-title m-0 text-center">{{ $t('NEW OFFERS') }}</h4>
                        <div class="d-flex justify-content-between mb-4">
                            <router-link :to="'/offers-board'" v-if="restOffers" class="btn btn-sm btn-primary">See {{ restOffers }} more</router-link>
                        </div>
                        <div class="row justify-content-center">
                                <div v-for="item in offersToShow" :key="item._id" class="col-12 col-md-6 col-xl-4 mb-3 mb-xl-0">
                                        <NegotiationsItem @click="openOffer" :item="item" pool-name="offer" :class="['list-item']"/>
                                </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-12">
                <div class="row">
                    <div class="col-12 col-lg-5 d-flex">
                        <div class="card flex-fill">
                            <div class="h-100 d-flex flex-column justify-content-between align-content-center">
                              <div class="card-body">
                                <div class="row">
                                  <div class="col-sm-6">
                                    <div>
                                      <h4 class="card-title mb-4">{{ $t('Available Balance')}}</h4>
                                      <h3>
                                        <span v-if="!loadedBalance"><i class="fas fa-spinner fa-spin"></i></span>
                                        <span v-else>&euro;{{balance.available_balance}}</span>
                                      </h3>
                                    </div>
                                  </div>
                                  <div class="col-sm-6">
                                    <div class="text-sm-right mt-4 mt-sm-0">
                                          <span
                                              v-b-tooltip.hover.auto
                                              :title="!canRequestPayout ? 'You do not have enough resources on your balance to request a payment.' : ''"
                                          >
                                              <button @click="requestPayout" class="btn btn-success" :disabled="!canRequestPayout" :class="{'not-allowed': !canRequestPayout}">
                                                  Request payment <i class="fas fa-comments-dollar"></i>
                                              </button>
                                          </span>
                                      <!--                                            <p class="text-muted mb-2">{{ $t('Requested payout')}}</p>-->
                                      <!--                                            <h5>-->
                                      <!--                                                + &euro;{{ balance.requested_payout }}-->
                                      <!--                                                <span class="badge badge-success ml-1 align-bottom">+ 31 %</span>-->
                                      <!--                                            </h5>-->
                                    </div>
                                  </div>
                                </div>
                              </div>

                              <div class="card-body border-top">
                                <div class="text-center">
                                  <div class="row">
                                    <div class="col-sm-6">
                                      <div>
                                        <p class="text-muted mb-2">Requested payment</p>
                                        <h5>
                                          <span v-if="!loadedBalance"><i class="fas fa-spinner fa-spin"></i></span>
                                          <span v-else>&euro;{{ balance.requested_payout }}</span>
                                        </h5>
                                      </div>
                                    </div>
                                    <div class="col-sm-6">
                                      <div class="mt-4 mt-sm-0">
                                        <p class="text-muted mb-2">Total paid</p>
                                        <h5>
                                          <span v-if="!loadedBalance"><i class="fas fa-spinner fa-spin"></i></span>
                                          <span v-else>&euro;{{ balance.total_paid }}</span>
                                        </h5>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                        </div>
                    </div>

                    <div class="col-12 col-lg-7">
                        <div class="row h-100">
                            <div class="col-12 col-md-4" v-for="chart in chartData" :key="chart.name">
                                <div class="card full-height-card">
                                    <div class="card-body">
                                        <div class="media">

                                            <div class="media-body">
                                                <h4 class="card-title mb-4">{{ chart.label }}</h4>
                                                <h5>{{ chart.value }}
<!--                                                    <span v-if="chart.positive" class="badge text-success mr-2">+ {{ chart.badgeValue }} <i-->
<!--                                                            class="mdi mdi-arrow-down"></i></span>-->
<!--                                                    <span v-else class="badge text-danger mr-2">- {{ chart.badgeValue }} <i-->
<!--                                                            class="mdi mdi-arrow-up"></i></span>-->
                                                </h5>
                                            </div>

                                        </div>
                                        <div class="pt-4">
                                            <apexchart
                                                    class="apex-charts"
                                                    height="100"
                                                    type="area"
                                                    dir="ltr"
                                                    :series="chart.series"
                                                    :options="chartOptions"
                                            ></apexchart>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-12">
                <div class="card">
                    <div class="card-body">
                        <h4 class="card-title  mb-4">{{ $t('Scheduled posts') }}</h4>
                        <div v-if="scheduledPosts.length" class="row">
                            <div class="col-12 col-md-4 col-lg-4 col-xl-3  mb-3" v-for="post in scheduledPosts"
                                 :key="post.media_url">
                                <social-card :post="post" type="scheduled"></social-card>
                            </div>
                        </div>
                        <div v-else>
                            <h5 class="text-muted text-center mb-4">
                                {{ $t('When you schedule campaign posts, we will show them here.')}}
                            </h5>
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-12">
                <div class="card">
                    <div class="card-body">
                        <h4 class="card-title mb-4">{{ $t('Social accounts overview')}}</h4>

                        <div class="table-responsive mt-4 mb-0">
                            <table class="table table-centered">
                                <tbody>
                                <tr v-for="social in socialNetworkData" :key="social.name">
                                    <td>
                                        <h5 class="font-size-14 mb-1">{{ social.name.charAt(0).toUpperCase() +
                                            social.name.slice(1) }}</h5>
                                        <p class="text-muted mb-0">{{ social.accountName }}</p>
                                    </td>

                                    <td>
                                        <p class="text-muted mb-1">{{ $t('Folowers')}}</p>
                                        <h5 class="mb-0">{{ social.followers.value }}
                                            <!--                                            <span v-if="social.followers.trend > 0" class="badge text-success mr-2"> + {{ social.followers.trend }}% <i class="mdi mdi-arrow-up"></i></span>-->
                                            <!--                                            <span v-else class="badge text-danger mr-2"> {{ social.followers.trend }}% <i class="mdi mdi-arrow-down"></i></span>-->
                                        </h5>
                                    </td>

                                    <td>
                                        <p class="text-muted mb-1">{{ $t('Impressions')}}</p>
                                        <h5 class="mb-0">{{ social.impressions.value }}
                                            <!--                                            <span v-if="social.impressions.trend > 0" class="badge text-success mr-2"> + {{ social.impressions.trend }}% <i class="mdi mdi-arrow-up"></i></span>-->
                                            <!--                                            <span v-else class="badge text-danger mr-2"> {{ social.impressions.trend }}% <i class="mdi mdi-arrow-down"></i></span>-->
                                        </h5>
                                    </td>
                                    <td>
                                        <p class="text-muted mb-1">{{ $t('Engagement rate')}}</p>
                                        <h5 class="mb-0">{{ social.engagement_rate.value }}%
                                            <!--                                            <span v-if="social.engagement_rate.trend > 0" class="badge text-success mr-2"> + {{ social.engagement_rate.trend }}% <i class="mdi mdi-arrow-up"></i></span>-->
                                            <!--                                            <span v-else class="badge text-danger mr-2"> {{ social.engagement_rate.trend }}% <i class="mdi mdi-arrow-down"></i></span>-->
                                        </h5>
                                    </td>
                                </tr>


                                <tr v-if="blog">
                                    <td>
                                        <h5 class="font-size-14 mb-1 text-capitalize">{{ blog.name }}</h5>
                                        <p class="text-muted mb-0">{{ blog.website }}</p>
                                    </td>

                                    <td>
                                        <p class="text-muted mb-1">{{ $t('Users')}}</p>
                                        <h5 class="mb-0">{{ blog.users.value.toLocaleString() }}</h5>
                                    </td>

                                    <td>
                                        <p class="text-muted mb-1">{{ $t('New users')}}</p>
                                        <h5 class="mb-0">{{ blog.new_users.value.toLocaleString() }}</h5>
                                    </td>
                                    <td>
                                        <p class="text-muted mb-1">{{ $t('Avg. session duration (sec)')}}</p>
                                        <h5 class="mb-0">{{ blog.avg_session_duration.value.toLocaleString() }}</h5>
                                    </td>
                                </tr>

                                </tbody>
                            </table>
                        </div>

                    </div>
                </div>
            </div>

            <div class="col-12">
                <div class="card">
                    <div class="card-body">
                        <h4 class="card-title  mb-4">{{ $t('Recent posts') }}</h4>
                        <div v-if="recentPosts.length" class="row">
                            <div class="col-12 col-md-4 col-lg-4 col-xl-3  mb-3" v-for="post in recentPosts"
                                 :key="post.media_url">
                                <social-card :post="post"></social-card>
                            </div>
                        </div>
                        <div v-else>
                            <h4 class="text-muted text-center  mb-4">
                                {{ $t('No data')}}
                            </h4>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!--modal-->
        <b-modal body-class="p-0" content-class="border-0"  @hidden="refreshPage" v-model="showModal" size="lg" centered hide-footer hide-header>
            <AgreementContent :agreement="modalAgreement" @closeModal="showModal = false" />
        </b-modal>

    </Layout>
</template>
